export default __webpack_public_path__ + "static/media/nss-4.79884f3f.png";